export * from "./PartnerList";
